export default __webpack_public_path__ + "static/media/account-side.12c49d37.jpg";